import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id BADFBFC4-21C7-4BDA-B6A7-16C83B32C37C
 * name train-car-hopper
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/train-car-hopper.svg
 * tags
 * - Transportation + Other 
 */
export const TrainCarHopperIcon = createSvgIcon(<><path d="M1 8V17H2C2 18.11 2.9 19 4 19S6 18.11 6 17H18C18 18.11 18.9 19 20 19S22 18.11 22 17H23V8H1M13 15V11H11V15H8V11H6V15H3V10H21V15H18V11H16V15H13Z" /></>, 'TrainCarHopperIcon');
export default TrainCarHopperIcon